import SearchIcon from "@mui/icons-material/Search";
import { Box, Chip, FormControl, IconButton, MenuItem, Pagination, Select} from "@mui/material";
import { DataGrid, GridToolbarColumnsButton } from "@mui/x-data-grid";
import { useCallback, useEffect, useState } from "react";
import Swal from "sweetalert2";
import { getPermissionData, getUserData } from "../../Actions/common";
import PowerSettingsNewOutlinedIcon from "@mui/icons-material/PowerSettingsNewOutlined";
import { getTermsAndConditionsByIdAction,listTermsAndConditionsAction, publishTermsAndConditions,} from "../../Actions/termsAndConditionsAction";
import { deleteSingleMultipleBusinessAction } from "../../Actions/whiteListpsAction";
import { DataGrid_SX } from "../../Assets/customTheme/constants";
import { CustomNoRowsOverlay } from "../../Assets/customTheme/CustomNoRowsOverlay";
import { default as CoustomTooltip, default as CustomTooltip } from "../../Assets/customTheme/customtooltip";
import { MyAddRoundedIcon, MyEditOutlinedIcon, MyVisibilityOutlinedIcon } from "../../Assets/svg/MyIcons";
import { TableColumns, TableFilte, TableReset } from "../../Assets/svg/svgicon";
import BreadcrumbsComponent from "../../components/Common/Breadcrumbs";
import { ITEMS_PER_PAGE_OPTIONS } from "../../config";
import { formatDateTime } from "../Common/DateFormat";
import CustomSnackbar from "../Common/snackBar";
import AddEditTermsConditionModal from "./AddEditTermsConditionModal";
import TermsAndConditionPreviewModal from "./TermsAndConditionPreviewModal";
import renderStatusBadge from "../../utils/badges";
import { CommonTooltip } from "../../utils/tooltip";
import showConfirmation from "../../utils/Conformation";

const CustomToolbar = ({ 
  hasPermission, 
  handleAddTemplate,
  searchValue, 
  handleSearchApi, 
  handleFilterData, 
  handleResetFilters, 
  filterButtonDisabled, 
  resetButtonDisabled,
  templateTypeFilter,
  statusFilter,
  isRequiredFilter,
  handleChangeDropdown 
}) => {
  return (
    <div className="custom-header ">
      <div className="card border-rounded-0 fiter-card">
        <div className="card-body p-5 pb-0">
          <div className="row">
            {/* Search Input */}
            <div className="col-xl-3 col-xxl-2 col-lg-3 col-md-4 col-sm-6 mb-5">
              <div className="input-group w-100">
                <div className="input-group-prepend">
                  <span className="input-group-text" id="basic-addon1">
                    <SearchIcon />
                  </span>
                </div>
                <input
                  type="text"
                  data-kt-table-widget-4="search"
                  className="form-control"
                  placeholder="Search by title"
                  name="search"
                  value={searchValue}
                  onChange={handleSearchApi}
                />
              </div>
            </div>

            {/* Template Type Filter */}
            <div className="col-xl-2 col-xxl-2 col-lg-3 col-md-3 col-sm-6 mb-5">
              <FormControl className="w-100">
                <Select
                  displayEmpty
                  value={templateTypeFilter}
                  name="templateType"
                  onChange={(e) => handleChangeDropdown(e, "templateType")}
                  sx={{
                    "& .MuiSelect-select": {
                        padding: "12px 10px",
                        textAlign: "start",
                        minHeight: "1em !important",
                    },
                    fieldset: {
                        borderColor: "#e1e3ea !important",
                        borderRadius: "0.475rem",
                    },
                  }}
                >
                  <MenuItem value="all">All Templates</MenuItem>
                  <MenuItem value="master">Master</MenuItem>
                  <MenuItem value="tenant">Tenant</MenuItem>
                  <MenuItem value="both">Both</MenuItem>
                </Select>
              </FormControl>
            </div>

            {/* Status Filter */}
            <div className="col-xl-2 col-xxl-2 col-lg-3 col-md-3 col-sm-6 mb-5">
              <FormControl className="w-100">
                <Select
                  displayEmpty
                  value={statusFilter}
                  name="status"
                  onChange={(e) => handleChangeDropdown(e, "status")}
                  sx={{
                    "& .MuiSelect-select": {
                        padding: "12px 10px",
                        textAlign: "start",
                        minHeight: "1em !important",
                    },
                    fieldset: {
                        borderColor: "#e1e3ea !important",
                        borderRadius: "0.475rem",
                    },
                  }}
                >
                  <MenuItem value="all">All Status</MenuItem>
                  <MenuItem value="true">Active</MenuItem>
                  <MenuItem value="false">Inactive</MenuItem>
                </Select>
              </FormControl>
            </div>

            {/* isRequired Filter */}
            <div className="col-xl-2 col-xxl-2 col-lg-3 col-md-3 col-sm-6 mb-5">
              <FormControl className="w-100">
                <Select
                  displayEmpty
                  value={isRequiredFilter}
                  name="isRequired"
                  onChange={(e) => handleChangeDropdown(e, "isRequired")}
                  sx={{
                    "& .MuiSelect-select": {
                        padding: "12px 10px",
                        textAlign: "start",
                        minHeight: "1em !important",
                    },
                    fieldset: {
                        borderColor: "#e1e3ea !important",
                        borderRadius: "0.475rem",
                    },
                  }}
                >
                  <MenuItem value="all">All Required</MenuItem>
                  <MenuItem value="true">Required</MenuItem>
                  <MenuItem value="false">Not Required</MenuItem>
                </Select>
              </FormControl>
            </div>

            {/* Action Buttons */}
            <div className="col-auto ms-auto d-flex flex-wrap gap-3 mb-5">
              <CustomTooltip title="Filter" placement="top" arrow>
                <button
                  className="btn text-primary btn-light btn-icon"
                  onClick={handleFilterData}
                  disabled={filterButtonDisabled}
                >
                  <TableFilte />
                </button>
              </CustomTooltip>
              
              <CustomTooltip title="Reset" placement="top" arrow>
                <button
                  className="btn text-primary btn-light btn-icon"
                  onClick={handleResetFilters}
                  disabled={resetButtonDisabled}
                >
                  <TableReset />
                </button>
              </CustomTooltip>

              <CoustomTooltip
                title="Column"
                placement="top"
                arrow
              >
                <span className="btn text-primary btn-light btn-icon grid-toolbar">
                  <GridToolbarColumnsButton
                    slotProps={{
                      button: {
                        className: "btn btn-light text-primary btn-icon grid-toolbar d-flex justify-content-center align-items-center p-0",
                        style: {
                          width: "47px",
                          height: "44px",
                          minWidth: "unset",
                          borderRadius: "8px",
                        },
                        startIcon: <TableColumns />,
                      },
                    }}
                  />
                </span>
              </CoustomTooltip>

              {hasPermission?.canCreate && (
                <button
                  className="btn btn-outline btn-primary btn-add"
                  onClick={(e) => handleAddTemplate(e)}
                >
                  <MyAddRoundedIcon className="me-1 text-white" /> ADD
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const TermsAndConditionsSection = () => {
  const [filterButtonDisabled, setFilterButtonDisabled] = useState(true);
  const [resetButtonDisabled, setResetButtonDisabled] = useState(true);
  const [searchValue, setSearchValue] = useState("");
  const [templateTypeFilter, setTemplateTypeFilter] = useState("all");
  const [statusFilter, setStatusFilter] = useState("all");
  const [isRequiredFilter, setIsRequiredFilter] = useState("all");
  const [loading, setLoading] = useState(true);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [selectedRows, setSelectedRows] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [shouldFetchData, setShouldFetchData] = useState(1);
  const [ipDataById, setIpDataById] = useState(null);
  const [whiteListIpsData, setWhiteListIpsData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [selectedRowsPerPage, setSelectedRowsPerPage] = useState(ITEMS_PER_PAGE_OPTIONS[0]);

  const [openModal, setOpenModal] = useState(false);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [previewContent, setPreviewContent] = useState(null);

  const userData = localStorage.getItem("userData") ? getUserData() : null;
  const permissionData = localStorage.getItem(`${userData?.id}_permissionData`) 
    ? getPermissionData(`${userData?.id}_permissionData`) 
    : [];
  const hasPermission = permissionData[0]?.role_permissions?.find(
    (m) => m?.module && m?.module?.slug === "terms-and-conditions"
  );

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const getWhiteListIps = useCallback(async () => {
    setLoading(true);
    try {
      const filterData = {
        page: currentPage,
        perPage: selectedRowsPerPage,
        searchQuery: searchValue || undefined,  // Ensure empty strings are not sent
        templateType: templateTypeFilter !== "all" ? templateTypeFilter : undefined,
        status: statusFilter !== "all" ? statusFilter : undefined,
        isRequired: isRequiredFilter !== "all" ? isRequiredFilter : undefined,
      };

      const response = await listTermsAndConditionsAction(filterData);
      
      setWhiteListIpsData(response?.data || []);
      setTotalCount(response?.totalCount || 0);
    } catch (error) {
      console.error('Error in getWhiteListIps:', error);
      setSnackbar({
        open: true,
        message: error?.response?.data?.message || "Failed to fetch data",
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  }, [currentPage, selectedRowsPerPage, searchValue, templateTypeFilter, statusFilter, isRequiredFilter]);

  useEffect(() => {
    if (shouldFetchData) {
      getWhiteListIps();
      setShouldFetchData(0);
    }
  }, [shouldFetchData, getWhiteListIps]);

  const handleChangeDropdown = (e, filterType) => {
    const value = e.target.value;
    
    if (filterType === "templateType") {
      setTemplateTypeFilter(value);
    } else if (filterType === "status") {
      setStatusFilter(value);
    } else if (filterType === "isRequired") {
      setIsRequiredFilter(value);
    }
    
    setFilterButtonDisabled(false);
    setResetButtonDisabled(false);
  };



  const handleSearchApi = (e) => {
    const inputValue = e.target.value.trim();
    setSearchValue(inputValue);
    
    if (
      inputValue.length === 0 && 
      templateTypeFilter === "all" && 
      statusFilter === "all" && 
      isRequiredFilter === "all"
    ) {
      setFilterButtonDisabled(true);
    } else {
      setFilterButtonDisabled(false);
    }
  };
  
  const handleDeleteSelected = () => {
    if (selectedRows.length === 0) {
      return;
    }

    Swal.fire({
      title: "Are you sure?",
      text: "You will not be able to recover these Merchant!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#22419e",
      cancelButtonColor: "#777777",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const data = {
          ids: selectedRows,
        };
        await deleteSingleMultipleBusinessAction(data)
          .then((res) => {
            Swal.fire({
              title: "Deleted!",
              text: res.message,
              icon: "success",
              confirmButtonColor: "#22419e",
            });
            setSelectedRows([]);
            setCurrentPage(1);
            getWhiteListIps();
          })
          .catch((error) => {
            setSnackbar({
              open: true,
              message: error.response.data.message,
              severity: "error",
            });
            setSelectedRows([]);
          });
      } else {
        Swal.fire({
          title: "Cancelled",
          text: "Your record is safe",
          icon: "error",
          confirmButtonColor: "#22419e",
        });
        setSelectedRows([]);
      }
    });
  };

  const handlePaginationChange = (event, value) => {
    setSelectedRows([]);
    setCurrentPage(value);
    setShouldFetchData(1);
  };

  const handleResetFilters = () => {
    setSearchValue("");
    setTemplateTypeFilter("all");
    setStatusFilter("all");
    setIsRequiredFilter("all");
    setCurrentPage(1);
    setShouldFetchData(1);
    setResetButtonDisabled(true);
    setFilterButtonDisabled(true);
  };

  const handleFilterData = () => {
    setLoading(true);
    setCurrentPage(1);
    setShouldFetchData(1);
    setFilterButtonDisabled(true);
    setResetButtonDisabled(false);
  };

  const handleRowsPerPageChange = (event) => {
    setWhiteListIpsData([]);
    setSelectedRows([]);
    const newValue = parseInt(event.target.value);
    setSelectedRowsPerPage(newValue);
    setCurrentPage(1);
    setLoading(true);
    setShouldFetchData(1);
  };

  const handleAddTemplate = async (e, row) => {
    if (row && row?.id) {
      await getTermsAndConditionsByIdAction(row?.id)
        .then((res) => {
          setIpDataById(res.data);
          setOpenModal(true);
        })
        .catch((error) => {
          setSnackbar({
            open: true,
            message: error?.response?.data?.message,
            severity: "error",
          });
        });
    } else {
      setOpenModal(true);
    }
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setIpDataById(null);
  };

  const handlePreview = (e, row) => {
    e.stopPropagation();
    setPreviewContent(row);
    setIsPreviewOpen(true);
  };

  const handleClosePreviewModal = () => {
    setIsPreviewOpen(false);
    setPreviewContent(null);
  };

  const handleToggleStatus = async (id, currentStatus) => {
      await showConfirmation("toggleStatus", {
          entityName: "Template",
          entityId: id,
          currentStatus: currentStatus,
          action: async () => {
              const response = await publishTermsAndConditions({ 
                  id, 
                  isActive: !currentStatus 
              });
              
              if (response?.status !== 200 && !response?.success) {
                  throw new Error(response?.message || "Failed to update template status.");
              }
              
              return response;
          },
          onSuccess: (response, newStatus) => {
              setSnackbar({ 
                  open: true, 
                  message: response?.message || `Template ${newStatus ? "activated" : "deactivated"} successfully.`, 
                  severity: "success" 
              });
              setShouldFetchData(1);
          },
          onError: (err) => {
              console.error("Error updating status:", err);
              setSnackbar({ 
                  open: true, 
                  message: err?.response?.data?.message || err?.message || "Something went wrong while updating status.", 
                  severity: "error" 
              });
          },
      });
  };

  const columns = [
    {
      field: "title",
      flex: 2,
      sortable: true,
      filterable: false,
      headerName: "Name",
    },
    {
      field: "templateType",
      headerName: "Template Type",
      flex: 1.2,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        const { isMaster, isTenant } = params.row;

        let label = "Unknown";
        let chipColor = "default";
        let borderColor = "grey.500";
        let bgColor = "transparent";

        if (isMaster && isTenant) {
          label = "Both";
          chipColor = "default";
          borderColor = "grey.500";
          bgColor = "transparent";
        } else if (isMaster) {
          label = "Master";
          chipColor = "primary.main";
          borderColor = "primary.main";
        } else if (isTenant) {
          label = "Tenant";
          chipColor = "secondary.main";
          borderColor = "secondary.main";
        }

        return (
          <Chip
            label={label}
            size="small"
            variant="outlined"
            sx={{
              fontWeight: 600,
              borderRadius: "8px",
              textTransform: "capitalize",
              color: chipColor,
              borderColor: borderColor,
              backgroundColor: bgColor,
            }}
          />
        );
      },
    },
    {
      field: "isRequired",
      flex: 1,
      sortable: false,
      filterable: false, 
      headerName: "isRequired",
      renderCell: (params) => {
        const isRequired = params.row?.isRequired;
        
        const statusMap = {
          true: { text: "True", status: "primary" },
          false: { text: "False", status: "default" },
        };

        const { text, status } = statusMap[isRequired] || {
          text: "Unknown",
          status: "default",
        };

        return renderStatusBadge({ status, title: text });
      },
    },
    {
      field: "isActive",
      headerName: "Status",
      flex: 1,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        const isActive = params.row?.isActive;
        
        const statusMap = {
          true: { text: "Active", status: "success" },
          false: { text: "Inactive", status: "error" },
        };

        const { text, status } = statusMap[isActive] || {
          text: "Unknown",
          status: "default",
        };

        return renderStatusBadge({ status, title: text });
      },
    },
    {
      field: "createdAt",
      flex: 1.5,
      sortable: true,
      filterable: false,
      headerName: "Created date",
      renderCell: (params) => <>{formatDateTime(params.row.createdAt, true)}</>,
    },
    ...(hasPermission?.canEdit || hasPermission?.canDelete 
      ? [
        {
          field: "actions",
          headerName: "Actions",
          flex: 1.2,
          sortable: false,
          filterable: false,
          align: "center",
          headerAlign: "center",
          renderCell: (params) => (
            <Box
              sx={{
                display: "flex",
                alignItems: "center", 
                justifyContent: "center",
                width: "100%",
                height: "100%", 
                gap: 1,
              }}
            >
              {hasPermission?.canEdit && (

                <CommonTooltip
                  title={params.row?.isActive ? "Deactivate Template" : "Activate Template"}
                >
                  <IconButton
                    className="btn-custom-i text-primary"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleToggleStatus(params.row?.id, params.row?.isActive);
                    }}
                  >
                    <PowerSettingsNewOutlinedIcon 
                      color={params.row?.isActive ? "error" : "success"}
                    />
                  </IconButton>
                </CommonTooltip>
              )}
              
              {hasPermission?.canEdit && (
                <CommonTooltip title="Edit">
                  <IconButton
                    className="btn-custom-i text-primary"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleAddTemplate(e, params.row);
                    }}
                  >
                    <MyEditOutlinedIcon />
                  </IconButton>
                </CommonTooltip>
              )}

              <CommonTooltip title="View Terms & Condition">
                <IconButton
                  className="btn-custom-i text-primary"
                  onClick={(e) => {
                    e.stopPropagation();
                    handlePreview(e, params.row);
                  }}
                >
                  <MyVisibilityOutlinedIcon />
                </IconButton>
              </CommonTooltip>
            </Box>
          ),
        }
      ]
  : []),
  ];

  return (
    <div id="kt_content_container">
      <BreadcrumbsComponent />

      <DataGrid
        className="border-0"
        localeText={{ toolbarColumns: "" }}
        rows={whiteListIpsData}
        columns={columns}
        autoHeight
        hideFooterRowCount={true}
        hideFooterPagination={true}
        hideFooter={true}
        loading={loading}
        slots={{
          toolbar: CustomToolbar,
          noRowsOverlay: CustomNoRowsOverlay,
        }}
        slotProps={{
          toolbar: {
            selectedRows,
            handleDeleteSelected,
            searchValue,
            handleSearchApi,
            handleFilterData,
            handleResetFilters,
            hasPermission,
            handleAddTemplate,
            templateTypeFilter,
            statusFilter,
            isRequiredFilter,
            handleChangeDropdown,
            filterButtonDisabled,
            resetButtonDisabled,
          },
        }}
        sx={DataGrid_SX}
      />

      {/* Pagination */}
      <div className="card-footer d-flex align-items-center justify-content-between mt-7">
        <div className="d-flex align-items-center">
          <label className="fw-semibold me-3">{"Row per page"}</label>
          <FormControl variant="standard" style={{ minWidth: 50 }}>
            <Select
              labelId="rows-per-page-label"
              id="rows-per-page"
              value={selectedRowsPerPage}
              onChange={handleRowsPerPageChange}
              label="Row per page"
            >
              {ITEMS_PER_PAGE_OPTIONS?.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        <Pagination
          count={Math.ceil(totalCount / selectedRowsPerPage)}
          siblingCount={0}
          page={currentPage}
          onChange={(event, value) => 
            value !== currentPage ? handlePaginationChange(event, value) : null
          }
          variant="outlined"
          shape="rounded"
          className="custom-pagination mt-0 ms-5"
        />
      </div>

      {isPreviewOpen && (
        <TermsAndConditionPreviewModal
          open={isPreviewOpen}
          handleClose={handleClosePreviewModal}
          contentData={previewContent}
        />
      )}

      {openModal && (
        <AddEditTermsConditionModal
          open={openModal}
          handleClose={handleCloseModal}
          templateDataById={ipDataById}
          setSnackbar={setSnackbar}
          getTemplateData={getWhiteListIps}
        />
      )}

      <CustomSnackbar
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={handleCloseSnackbar}
      />
    </div>
  );
};

export default TermsAndConditionsSection;